<div class="delivery-card" [class.signed]="signed" [class.highlight]="highlight"
	(mouseenter)="onCardEnter($event)" (mouseleave)="onCardLeave()" (mousedown)="onCardDown()">
	@if (seq !== null) {
		<div class="seq-badge" [style.background]="color">{{ seq }}</div>
	}
	<!-- Repère de carte : posé EN ABSOLU dans le coin bas droit (l'ordre DOM ne dit pas sa place),
	     par-dessus la fin du créneau demandé. En haut à gauche il coûtait 30 px de largeur à
	     toutes les lignes de la vignette, qui repliaient et allongeaient la colonne. -->
	@if (showRef) {
		<div class="seq-badge ref" title="Repère de cette livraison sur la carte">{{ ref }}</div>
	}
	<div class="card-body">
		<div class="card-line title-line">
			<a class="order-link" [routerLink]="[rental ? '/rental' : '/sales/quotation', delivery.id_order]" (click)="$event.stopPropagation()">#{{ delivery.id_order }}</a>
			<span class="customer">{{ customerName }}</span>
			@if (signed) {
				<span class="badge-signed"><mat-icon inline>task_alt</mat-icon>&nbsp;BL signé</span>
			}
			<button type="button" class="bl-eye" [class.pinned]="blPinned()" title="Voir le contenu du BL"
				(click)="onTogglePin($event)" (mousedown)="$event.stopPropagation()">
				<mat-icon inline>visibility</mat-icon>
			</button>
		</div>
		@if (address) {
			<div class="card-line muted"><mat-icon inline>place</mat-icon><span>{{ address }}</span></div>
		}
		@if (tel) {
			<div class="card-line muted"><mat-icon inline>call</mat-icon><span>{{ tel }}</span></div>
		}
		@if (products.length) {
			<div class="card-line muted products"><mat-icon inline>inventory_2</mat-icon><span>{{ products.join(', ') }}</span></div>
		}
		<!-- full-left : dans une tournée, la ligne « convenu client » s'étend jusqu'au bord gauche
		     de la vignette (sous le badge) pour ne jamais être tronquée.
		     with-ref : hors tournée, elle réserve son coin bas droit au repère de carte. -->
		<div class="card-line ask" [class.asap]="asap" [class.full-left]="seq !== null" [class.with-ref]="showRef">
			<mat-icon inline>schedule</mat-icon>
			@if (askDate) {
				<span class="ask-date">{{ askDate }}</span>
			}
			<span>{{ askLabel }}</span>
			@if (editDuration) {
				<span class="duration-edit" title="Temps sur place chez le client (minutes)"
					(mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
					<input type="number" min="0" max="999" [step]="durationStepMin" inputmode="numeric" [value]="durationMin"
						(keydown)="onDurationKeydown($event)" (change)="onDurationMinChange($any($event.target).value)">
					<span>min</span>
				</span>
			}
		</div>
	</div>
</div>

<!-- Aperçu du contenu du BL : panneau flottant (cdk Overlay), ouvert au survol 1 s ou épinglé via l'icône -->
<ng-template #blPanel>
	<div class="bl-preview" (mouseenter)="cancelScheduledClose()" (mouseleave)="onCardLeave()">
		<div class="bl-head">
			<span class="bl-title">BL #{{ delivery.id }} · Cde #{{ delivery.id_order }}</span>
			<span class="bl-customer">{{ customerName }}</span>
			@if (blPreview(); as p) {
				@if (p.count > 1) {
					<span class="bl-count" title="Cette commande a plusieurs BL (reliquats)">BL {{ p.index }}/{{ p.count }}</span>
				}
			}
		</div>
		@if (addressDetails.length || tel) {
			<div class="bl-address">
				<mat-icon inline>place</mat-icon>
				<div>
					@for (l of addressDetails; track $index) { <div>{{ l }}</div> }
					@if (tel) { <div>Tél : {{ tel }}</div> }
				</div>
			</div>
		}
		@if (blPreview()?.signed) {
			<div class="bl-signed"><mat-icon inline>task_alt</mat-icon>&nbsp;BL signé le {{ signedDateLabel }}</div>
		}
		@if (blLoading()) {
			<div class="bl-loading">Chargement du BL…</div>
		} @else if (blError()) {
			<div class="bl-error">Impossible de charger le contenu du BL</div>
		} @else {
			@if (blPreview(); as p) {
				@if (!p.lines.length) {
					<div class="bl-empty">Aucune ligne dans ce BL</div>
				}
				<div class="bl-lines">
					@for (l of p.lines; track $index) {
						<div class="bl-line" [class.orphan]="l.orphan" [class.zero]="!l.qty">
							@if (blHasDirection()) {
								<app-rental-direction class="bl-dir" [typ]="l.typ" [qty]="l.reprise ? -l.qty : l.qty"></app-rental-direction>
							}
							<span class="bl-qty" [class.partial]="l.partial">{{ qtyOf(l.qty) }}@if (l.partial) {<span class="bl-ordered">/{{ qtyOf(l.ordered) }}</span>}</span>
							<span class="bl-name">{{ l.name }}@if (l.article) {<span class="bl-article">{{ l.article }}</span>}</span>
							@if (l.partial) {
								<span class="bl-flag" title="Quantité partielle : {{ qtyOf(l.qty) }} sur {{ qtyOf(l.ordered) }} commandés">partiel</span>
							}
							@if (l.orphan) {
								<span class="bl-flag orphan" title="Ligne absente des lignes actuelles de la commande">hors commande</span>
							}
						</div>
					}
				</div>
				<!-- Mémo de la livraison (attach is_default_memo) : édité à la volée, enregistré au blur.
				     Le panneau s'épingle dès que le champ prend le focus (onMemoFocus), sinon la souris qui
				     s'écarte le fermerait en pleine frappe. -->
				<div class="bl-memo" (mousedown)="$event.stopPropagation()">
					<div class="bl-memo-head">
						<mat-icon inline>sticky_note_2</mat-icon><span>Mémo</span>
						@if (memoSaving()) { <span class="bl-memo-state">enregistrement…</span> }
					</div>
					<textarea rows="2" placeholder="Code portail, étage, consignes de livraison…" [value]="memo()"
						(focus)="onMemoFocus()" (input)="onMemoInput($any($event.target).value)" (blur)="onMemoBlur()"></textarea>
				</div>
				<div class="bl-foot">
					<span class="bl-total">{{ totalOf(p) }}</span>
					<span class="bl-acts">
						@if (rental) {
							<a href="" (click)="openRentalBl($event)" title="Fenêtre de livraison location : ce BL seul, sans l'historique du dossier">
								Ouvrir la planification BL&nbsp;<mat-icon inline>open_in_new</mat-icon>
							</a>
						} @else {
							<a [routerLink]="['/logistic/delivery', delivery.id_order]" [queryParams]="{ index: p.index - 1 }" (click)="closePreview()">
								Ouvrir la planification BL&nbsp;<mat-icon inline>open_in_new</mat-icon>
							</a>
						}
						<button mat-icon-button type="button" class="print" [disabled]="printing()" title="Imprimer le BL" (click)="printBl()">
							<mat-icon>print</mat-icon>
						</button>
					</span>
				</div>
			}
		}
	</div>
</ng-template>
